export default __webpack_public_path__ + "static/media/sponsor-icon.c046453e.webp";